export const getTimestamp = (): number => Math.floor(Date.now() / 1000);
